import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useState } from 'react';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { Icon, ChevronDownSVGpath } from '@skatteetaten/ds-icons';
import './styles.css';


const getOpenCloseIconPositionDefault = ()=>'left';
const getOpenCloseUnderlineDefault = ()=>true;
const getOpenCloseVariantDefault = ()=>'standard';

var styles = {
    "tag": "OpenClose-module_tag__Nzpo9",
    "openClose": "OpenClose-module_openClose__CBceN",
    "openClose_compact": "OpenClose-module_openClose_compact__rfFwL",
    "openClose_hasIconRight": "OpenClose-module_openClose_hasIconRight__0rbZU",
    "icon_active": "OpenClose-module_icon_active__Gf73j",
    "icon": "OpenClose-module_icon__tAVZt",
    "icon_open": "OpenClose-module_icon_open__ZHkaj",
    "icon_closed": "OpenClose-module_icon_closed__aEh53",
    "icon_compact": "OpenClose-module_icon_compact__relka",
    "title": "OpenClose-module_title__6caTE",
    "title_underline": "OpenClose-module_title_underline__p-e0Y",
    "title_compact": "OpenClose-module_title_compact__90-Ze",
    "content": "OpenClose-module_content__XL8hj",
    "content_compact": "OpenClose-module_content_compact__Mn8kj",
    "content_hasIconRight": "OpenClose-module_content_hasIconRight__dnNxE"
};

const OpenClose = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, title, titleAs: HeadingTag, variant = getOpenCloseVariantDefault(), iconPosition = getOpenCloseIconPositionDefault(), isExpanded: isExpandedExternal, isDefaultExpanded, isOnClickOnlyFiredOnOpen, showUnderline = getOpenCloseUnderlineDefault(), onClick, children }, ref)=>{
    const [isExpandedInternal, setIsExpandedInternal] = useState(isDefaultExpanded ?? false);
    const isExpanded = isExpandedExternal !== undefined ? isExpandedExternal : isExpandedInternal;
    const Tag = HeadingTag ?? 'div';
    const hasIconRight = iconPosition === 'right';
    const isCompact = variant === 'compact';
    const handleClick = (e)=>{
        if (isOnClickOnlyFiredOnOpen) {
            !isExpanded && onClick?.(e);
        } else {
            onClick?.(e);
        }
        setIsExpandedInternal(!isExpanded);
    };
    const iconRightClassName = hasIconRight ? styles.openClose_hasIconRight : '';
    const compactClassName = isCompact ? styles.openClose_compact : '';
    const openCloseClassName = `${styles.openClose} ${compactClassName} ${iconRightClassName}`.trim();
    const iconClassName = `${styles.icon} ${styles.icon_active} ${isExpanded ? styles.icon_open : styles.icon_closed} ${isCompact ? styles.icon_compact : ''}`.trim();
    const titleClassName = `${styles.title} ${isCompact ? styles.title_compact : ''} ${showUnderline ? styles.title_underline : ''}`.trim();
    const contentClassName = `${styles.content} ${isCompact ? styles.content_compact : ''} ${hasIconRight ? styles.content_hasIconRight : ''}`.trim();
    return /*#__PURE__*/ jsxs("div", {
        className: className,
        children: [
            /*#__PURE__*/ jsx(Tag, {
                className: styles.tag,
                children: /*#__PURE__*/ jsxs("button", {
                    ref: ref,
                    id: id,
                    className: openCloseClassName,
                    lang: lang,
                    "data-testid": dataTestId,
                    "aria-expanded": isExpanded,
                    type: 'button',
                    onClick: handleClick,
                    children: [
                        /*#__PURE__*/ jsx(Icon, {
                            svgPath: ChevronDownSVGpath,
                            className: iconClassName,
                            size: isCompact ? 'medium' : 'large'
                        }),
                        /*#__PURE__*/ jsx("span", {
                            className: titleClassName,
                            children: title
                        })
                    ]
                })
            }),
            isExpanded && /*#__PURE__*/ jsx("div", {
                className: contentClassName,
                children: children
            })
        ]
    });
});
OpenClose.displayName = 'OpenClose';

export { OpenClose, getOpenCloseIconPositionDefault, getOpenCloseUnderlineDefault, getOpenCloseVariantDefault };
